module.exports = __webpack_public_path__ + "static/media/wallrus-2016-white-copy@3x.139fa5e8.png";